import $ from 'jquery'

const texts = document.querySelectorAll('.text-animation')
const heros = document.querySelectorAll('.hero')
const observer_options = {
  text: {},
  header: {}
}
const observer_text = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-show')
    }
  })
}, observer_options.text)

const observer_header = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      document.querySelector('.fixed-header').classList.remove('is-show')
    } else {
      document.querySelector('.fixed-header').classList.add('is-show')
    }
  })
}, observer_options.header)

texts.forEach(text => {
  observer_text.observe(text)
})
heros.forEach(hero => {
  observer_header.observe(hero)
})

// 読み込み時に追従ヘッダーが見えてしまうので時間差でclass付与
setTimeout(() => {
  document.querySelector('.fixed-header').classList.add('is-ready')
}, .3)

$('.btn-cta').on('click', () => {
  const offset = $('.hero_form').offset().top
  $('html, body').animate({ scrollTop: offset }, 1000)
})

$(function() {
  if ($('.form-attention').length > 0) {
      $('html, body').animate({ scrollTop: $('.hero_form').offset().top }, 1000)
  }
})
